import React from 'react';
import { studentTabTypes } from '../types';
import { Control, UseFormSetValue } from 'react-hook-form';
import { StudentDetailProps } from '../types/studentDetailType';
import { Box, Divider } from '@mui/material';
import { SectionTitle, TitleBorderWrapper } from '../styled';
import FormRenderer from '../../../components/FormRenderer/FormRenderer';
import { SnackbarSeverityType } from '../../../enums';
import {
  studentAcademicInfoSchema,
  studentHealthInfoSchema,
  studentMiscellaneousInfoSchema
} from '../config/schema';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import StudentProfile from './StudentProfile';
import { useSchoolStructure } from '../../common/hooks/useSchoolStructure';

const StudentTabContent = ({
  activeTab,
  control,
  setValue,
  showToast
}: {
  activeTab: studentTabTypes;
  control: Control<StudentDetailProps, any, StudentDetailProps>;
  setValue: UseFormSetValue<StudentDetailProps>;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}) => {
  const { schoolClassesConfig } = useSelector(
    (state: RootState) => state.schoolConfig
  );

  const divisionOptions = (schoolClassesConfig?.divisions || []).map(
    (grade: string) => ({
      label: grade,
      value: grade
    })
  );

  const { activityGroupsOptions } = useSchoolStructure();

  const formSections = {
    studentAcademicInfo: {
      title: 'Student Academic Information',
      schema: studentAcademicInfoSchema(
        divisionOptions,
        activityGroupsOptions || []
      )
    },
    studentDemographicInfo: {
      title: 'Student Demographic Information',
      schema: studentMiscellaneousInfoSchema
    },
    studentHealthInfo: {
      title: 'Student Health Information',
      schema: studentHealthInfoSchema
    }
  };
  switch (activeTab) {
    case 'studentProfile':
      return (
        <StudentProfile
          control={control}
          setValue={setValue}
          showToast={showToast}
        />
      );

    default:
      return (
        <Box sx={{ overflow: 'hidden' }}>
          <TitleBorderWrapper>
            <SectionTitle>{formSections[activeTab].title}</SectionTitle>
            <Divider sx={{ width: '100%' }} />
          </TitleBorderWrapper>
          <FormRenderer
            control={control}
            setValue={setValue}
            schema={formSections[activeTab].schema}
          />
        </Box>
      );
  }
};

export default StudentTabContent;
